import { Injectable } from '@angular/core';
import { environment } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class WmApiMetaService {
  metaFactory: any = {
    Artifacts: {
      getDependencies: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/artifacts/:artifactType/dependencies",
        method: "GET"
      }
    },
    Studio: {
      getPreferences: {
        url: environment.SERVICES_BASE_PATH + "services/studio/preferences/",
        method: "GET"
      },
      setPreferences: {
        url: environment.SERVICES_BASE_PATH + "services/studio/preferences/",
        method: "POST"
      },
      prefabs: {
        url: environment.SERVICES_BASE_PATH + "services/prefabs",
        method: "GET"
      },
      ServerLogs: {
        url: environment.SERVICES_BASE_PATH + "services/studio/logs/server/:lineCount",
        method: "GET"
      },
      AllLogs: {
        url: environment.SERVICES_BASE_PATH + "services/studio/logs/download",
        method: "GET"
      },
      ApplicationLogs: {
        url: environment.SERVICES_BASE_PATH + "services/studio/logs/application/:lineCount",
        method: "GET"
      },
      about: {
        url: environment.SERVICES_BASE_PATH + "services/studio/about",
        method: "GET",
        spinnerInfo: {
          showSpinner: false
        },
        embedModeAPI: true
      },
      organizationsList: {
        url: "/login/rest/profile/enterprises",
        method: "GET",
        spinnerInfo: {
          showSpinner: false
        },
        embedModeAPI: true
      },
      switchOrganization: {
        url: "/login/rest/profile/enterprises/:id/actions/switch",
        method: "POST"
      }
    },
    ProjectShell: {
      list: {
        url: environment.SERVICES_BASE_PATH + "services/projectShells",
        method: "GET"
      },
      remove: {
        url: environment.SERVICES_BASE_PATH + "services/projectShells/:projectShellID/versions/:versionId",
        method: "DELETE"
      }
    },
    Theme: {
      listInStudio: {
        url: environment.SERVICES_BASE_PATH + "services/themes?platformType=:platformType",
        method: "GET",
        spinnerInfo: {
          showSpinner: false
        }
      },
      listInProject: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/themes",
        method: "GET",
        spinnerInfo: {
          showSpinner: false
        }
      },
      import: {
        url: environment.SERVICES_BASE_PATH + "services/themes/import",
        method: "POST",
        params: {
          "packageType": 'THEME'
        }
      },
      importToProject: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/themes/import?retainExisting=true",
        method: "POST",
      },
      register: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/themes/register?retainExisting=true",
        method: "POST",
        spinnerInfo: {
          showSpinner: false
        }
      },
      deRegister: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/themes/deregister",
        method: "POST",
        spinnerInfo: {
          showSpinner: false
        }
      },
      getActive: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/themes/active",
        method: "GET",
        spinnerInfo: {
          showSpinner: false
        }
      },
      setActive: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/themes/activate",
        method: "POST",
        spinnerInfo: {
          showSpinner: false
        }
      },
      deActive: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/themes/deactivate",
        method: "POST",
        spinnerInfo: {
          showSpinner: false
        }
      },
      remove: {
        url: environment.SERVICES_BASE_PATH + "services/themes/:themeID/versions/:versionId",
        method: "DELETE"
      }
    },
    Prefab: {
      list: {
        url: environment.SERVICES_BASE_PATH + "services/prefabs?projectID=:projectID",
        method: "GET"
      },
      listAppPrefabs: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs",
        method: "GET"
      },
      getConfig: {
        url: "prefabs/:prefab/webapp/config.json",
        method: "GET"
      },
      register: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs",
        method: "POST"
      },
      deRegister: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs",
        method: "DELETE"
      },
      import: {
        url: environment.SERVICES_BASE_PATH + "services/import",
        method: "POST",
        headers: {
          'Content-Type': undefined
        },
        params: {
          "packageType": 'PREFAB'
        }
      },
      export: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/export",
        method: "POST"
      },
      downloadZip: {
        url: environment.SERVICES_BASE_PATH + "services/download?fileType=zip&packageType=prefab&sourceName=:projectID&targetName=:path",
        method: "GET"
      },
      remove: {
        url: environment.SERVICES_BASE_PATH + "services/prefabs/:prefabID/versions/:versionId?projectId=:projectId",
        method: "DELETE"
      },
      getServerProps: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs/properties/metadata",
        method: "GET"
      },
      setServerProps: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs/properties/metadata",
        method: "POST"
      },
      updateAppProps: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/properties",
        method: "PUT"
      },
      getAppPrefabServerProps: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs/:prefabName/properties",
        method: "GET"
      },
      setAppPrefabServerProps: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs/:prefabName/properties",
        method: "POST"
      },
      publishToWorkSpace: {
        url: environment.SERVICES_BASE_PATH + "services/prefabs/:projectID/publish",
        method: "POST"
      },
      publishPrefabToProject: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs/publish/app?forceRegister=:forceRegister",
        method: "POST"
      }
    },
    PageTemplates: {
      listBundles: {
        url: environment.SERVICES_BASE_PATH + "services/templatebundles/bundles",
        method: "GET"
      },
      listTemplates: {
        url: environment.SERVICES_BASE_PATH + "services/templatebundles?platformType=:platformType",
        method: "GET"
      },
      export: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/export",
        method: "POST"
      },
      remove: {
        url: environment.SERVICES_BASE_PATH + "services/templatebundles/:templateBundleId/versions/:versionId",
        method: "DELETE"
      },
      import: {
        url: environment.SERVICES_BASE_PATH + "services/import",
        method: "POST",
        headers: {
          'Content-Type': undefined
        },
        params: {
          "packageType": 'TEMPLATEBUNDLE'
        }
      },
      listCategories: {
        url: environment.SERVICES_BASE_PATH + "services/templatebundles/categories/:platformType",
        method: "GET"
      }
    },
    WidgetTemplates: {
      getTemplateMarkup: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/templatebundles/:templateBundleId/versions/:versionId/files/widgetTemplates/:templateId/:templateId.html",
        method: "GET"
      },
    },
    FILE: {
      remove: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
        method: "DELETE"
      },
      uploadPrefab: {
        url: environment.SERVICES_BASE_PATH + "services/prefabs",
        method: "POST",
        headers: {
          'Content-Type': undefined
        }
      },
      registerFileService: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/fileservice/register",
        method: "POST"
      },
      addFolder: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:folderPath",
        method: "PUT"
      },
      read: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
        method: "GET"
      },
      readDir: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/info/web/:filePath",
        method: "GET"
      },
      write: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
        method: "POST"
      },
      upload: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
        method: "POST",
        headers: {
          'Content-Type': undefined
        }
      },
    },
    Connector: {
      upload: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/connectors/import",
        method: "POST",
        headers: {
          'Content-Type': undefined
        }
      },
      remove: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/connectors/:connectorName",
        method: "DELETE",
        headers: {
          'Content-Type': undefined
        }
      }
    },
    Database: {
      testConnection: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/testConnection",
        method: "POST"
      },
      testDatabase: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/testDatabase",
        method: "POST"
      },
      testJarRequired: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/testDriver?dbType=:dbType",
        method: "GET"
      },
      read: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/read",
        method: "POST"
      },
      create: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/create",
        method: "POST"
      },
      readExistingDB: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/read",
        method: "POST"
      },
      reImportExistingDB: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/sources",
        method: "POST"
      },
      reImportCorruptDB: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/sources/update",
        method: "POST"
      },
      importDB: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/import",
        method: "POST"
      },
      reImportDB: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/sources/update",
        method: "POST"
      },
      exportDB: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/export",
        method: "POST"
      },
      loadModelInfo: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/loadModelInfo",
        method: "POST"
      },
      listTables: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/listTables",
        method: "POST"
      },
      getGeneratorTypes: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/configuration/:dbType",
        method: "GET"
      },

      /*DataModel related services*/
      getAllDataModels: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels",
        method: "GET"
      },
      getDataModel: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName?isdraft=:isdraft",
        method: "GET"
      },
      createDatabase: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database",
        method: "POST"
      },
      createService: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services",
        method: "POST"
      },
      deleteService: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName",
        method: "DELETE"
      },
      saveDataModel: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/save",
        method: "POST"
      },
      applyDataModel: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/update",
        method: "POST"
      },
      revertDataModel: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/revert",
        method: "POST"
      },
      dataModelDiff: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/changes",
        method: "GET"
      },

      /*Entities related services*/

      getAllEntities: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables",
        method: "GET"
      },
      getEntity: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:tableName",
        "method": "GET"
      },
      createEntity: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables",
        method: "POST"
      },
      updateEntity: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName",
        method: "POST"
      },
      deleteEntity: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName",
        method: "DELETE"
      },

      /*Entity Columns related services*/
      addUniqueKey: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/constraints",
        method: "POST"
      },
      deleteUniqueKey: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/constraints/:uniquekeyname",
        method: "DELETE"
      },
      addPrimaryKey: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/primaryKey",
        method: "PUT"
      },
      addColumns: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/columns",
        method: "POST"
      },
      updateColumn: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/columns/:columnName?forceDataLoss=:forceDataLoss",
        method: "PUT"
      },
      deleteColumn: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/columns/:columnName",
        method: "DELETE"
      },

      /*Services related to relations*/

      addRelation: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/relations",
        method: "POST"
      },
      updateRelation: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/relations/:relationName",
        method: "PUT"
      },
      deleteRelation: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/relations/:relationName",
        method: "DELETE"
      },
      getTypesMap: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/configuration",
        method: "GET"
      },
      getSequences: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/sequences",
        method: "GET"
      },

      /*Queries Related services*/

      getAllQueries: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries",
        method: "GET"
      },
      getQuery: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName",
        method: "GET"
      },
      createQuery: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries",
        method: "POST"
      },
      updateQuery: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName",
        method: "PUT"
      },
      queryNameUsage: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName/usages",
        method: "GET"
      },
      deleteQuery: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName",
        method: "DELETE"
      },
      setQueryMetaData: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName/metadata",
        method: "POST"
      },
      validateQuery: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/query/validate",
        method: "POST"
      },
      getAllProcedures: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures",
        method: "GET"
      },
      getProcedure: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures/:procedureName",
        method: "GET"
      },
      createProcedure: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures",
        method: "POST"
      },
      updateProcedure: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures/:procedureName",
        method: "PUT"
      },
      deleteProcedure: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures/:procedureName",
        method: "DELETE"
      },
      readTableData: {
        url: "/:service/:dataModelName/:entityName?page=:page&size=:size&:sort",
        method: "GET"
      },
      insertTableData: {
        url: "/:service/:dataModelName/:entityName",
        method: "POST"
      },
      insertMultiPartTableData: {
        url: "/:service/:dataModelName/:entityName",
        method: "POST",
        headers: {
          'Content-Type': undefined
        },
        // transformRequest: WM.identity TODO
      },
      updateTableData: {
        url: "/:service/:dataModelName/:entityName/:id",
        method: "PUT"
      },
      updateMultiPartTableData: {
        url: "/:service/:dataModelName/:entityName/:id",
        method: "POST",
        headers: {
          'Content-Type': undefined
        },
        // transformRequest: WM.identity
      },
      deleteTableData: {
        url: "/:service/:dataModelName/:entityName/:id",
        method: "DELETE"
      },
      updateCompositeTableData: {
        url: "/:service/:dataModelName/:entityName/composite-id?:id",
        method: "PUT"
      },
      periodUpdateCompositeTableData: {
        url: "/:service/:dataModelName/:entityName/composite-id/periods?:id",
        method: "PUT"
      },
      updateMultiPartCompositeTableData: {
        url: "/:service/:dataModelName/:entityName/composite-id?:id",
        method: "POST",
        headers: {
          'Content-Type': undefined
        },
        // transformRequest: WM.identity
      },
      deleteCompositeTableData: {
        url: "/:service/:dataModelName/:entityName/composite-id?:id",
        method: "DELETE"
      },
      periodDeleteCompositeTableData: {
        url: "/:service/:dataModelName/:entityName/composite-id/periods?:id",
        method: "DELETE"
      },
      countTableDataWithQuery: {
        url: "/:service/:dataModelName/:entityName/count",
        method: "POST",
        headers: {
          'Content-Type': "application/x-www-form-urlencoded"
        }
      },
      searchTableData: {
        url: "/:service/:dataModelName/:entityName/search?page=:page&size=:size&:sort",
        method: "POST"
      },
      searchTableDataWithQuery: {
        url: "/:service/:dataModelName/:entityName/filter?page=:page&size=:size&:sort",
        method: "POST",
        headers: {
          'Content-Type': "application/x-www-form-urlencoded"
        }
      },
      getDistinctDataByFields: {
        url: "/:service/:dataModelName/:entityName/aggregations?page=:page&size=:size&:sort",
        method: "POST"
      },
      exportTableData: {
        url: environment.SERVICES_BASE_PATH + "services/:dataModelName/:entityName/export?:sort",
        method: "POST"
      },
      readTableRelatedData: {
        url: "/:service/:dataModelName/:entityName/:id/:relatedFieldName?page=:page&size=:size&:sort",
        method: "GET"
      },
      executeNamedQuery: {
        url: "/:service/:dataModelName/queryExecutor/queries/:queryName?page=:page&size=:size&:queryParams",
        method: "GET"
      },
      executeCustomQuery: {
        url: "/:service/:dataModelName/queries/execute?page=:page&size=:size",
        method: "POST"
      },
      executeAggregateQuery: {
        url: environment.SERVICES_BASE_PATH + "services/:dataModelName/:entityName/aggregations?page=:page&size=:size&sort=:sort",
        method: "POST"
      },
      testRunQuery: {
        url: "/:service/:dataModelName/queries/test_run",
        method: "POST"
      },
      nativeTestRunQuery: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/queries/testrun",
        method: "POST"
      },


      /*Procedure related properties*/
      executeNamedProcedure: {
        url: "/:service/:dataModelName/procedureExecutor/procedure/execute/:procedureName?page=:page&size=:size&:procedureParams",
        method: "GET"
      },
      testRunProcedure: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/procedures/testrun",
        method: "POST",
        headers: {
          'Content-Type': undefined
        }
      },
      proceduresInDatabase: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/procedures",
        method: "GET"
      },

      /*Database connection properties*/
      getSampleDbConnectionProperties: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/sample/connectionProps?sampleDbName=:sampleDbName",
        method: "GET"
      },
      getConnectionProperties: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/properties",
        method: "GET"
      },
      updateConnectionProperties: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/properties",
        method: "PUT"
      },

      // read and update offline configuration
      updateOfflineConfig: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/offline",
        method: "POST"
      },
      getOfflineConfig: {
        url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/offline",
        method: "GET"
      }
    }
  };
  constructor() { }

  getApiMeta(target: string, action: string): any {
    const meta = this.getMeta();
    return meta[target] && meta[target][action];
  }
  getMeta(): any {
    return this.metaFactory
  }

  register(target: string, actions: any) {
    this.metaFactory[target] = actions;
  }
}
